import { useCallback, useEffect, useState } from "react";
import { MAX_RETRIES } from "../../configs/configs";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";
import useRetry from "../Common/useRetry";

function useGetCategoryConfig() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [category, setCategory] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const { retryCount, setRetryCount } = useRetry(
    () => getCategoryConfig(),
    MAX_RETRIES
  );

  const getCategoryConfig = useCallback(() => {
    fetchWrapper({
      endpoint_url: "category/getCategoryConfig",
      method: "GET",
      setLoading: setCategoryLoading,
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          let data = fetch_output["data"];
          setCategory(data);
          setRetryCount(0);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "fetch",
            message: "Get Category",
          });

        setRetryCount((prev) => prev + 1);
      },
      onResponseError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({
            apiType: "response",
            message: "Get Category",
          });

        setRetryCount((prev) => prev + 1);
      },
    });
  }, [fetchWrapper]);

  useEffect(() => {
    getCategoryConfig();
  }, []);

  return { category, categoryLoading, getCategoryConfig };
}

export default useGetCategoryConfig;
